<template>
  <div class="route-view-card ma-0 pa-15 fill-height d-flex flex-column">
    <span class="titulo"> Selecione o mercados de destino </span>

    <div class="subtitulo  mt-8"> Sinais clínicos apresentados no lote</div>

    <v-row>
      <v-col cols="4">
        <v-autocomplete @input="selecionarMercadoDestino($event)" :items="listaMercadoDestino"
                        clearable hide-details cache-items color="primary" solo return-object
                        item-text="dsMercadoDestino" label="Busque por mercados de destino">
        </v-autocomplete>
        <mercado-destino-chip-group v-if="listaMercadoDestino.length > 0" :listaMercadoDestino="listaMercadoDestino"
                                    :mercadosDestino="boletimSanitario.mercadosDestino"
                                    @selecionarMercadoDestino="selecionarMercadoDestino($event)" />
      </v-col>
      <v-col cols="8">
        <div class="card--mensagens--relacionadas d-flex flex-column pa-4 elevation-1">
          <span class="titulo--mensagens">
            Mensagens relacionadas aos animais:
          </span>
          <div class="exibicao--mensagens pt-2 mt-6">
            <div v-if="listaMensagensSelecionadas.length === 0" class="placeholder--mensagens">
              Busque e selecione os destinos no campo à esquerda.
            </div>
            <div v-else v-for="(mensagem, idx) in listaMensagensSelecionadas" :key="'msgs__'+idx">
              <pre class="mensagem-text mt-2">{{ mensagem }}</pre>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MercadoDestinoChipGroup from "./MercadoDestinoChipGroup";
import {MODELS} from "../resources";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

export default {
  name: "MercadoDestinoBoletimSanitario",
  components: {MercadoDestinoChipGroup},
  mixins: [validationMixin],
  validations() {
    if (this.step !== 4) return { boletimSanitario: {}}

    return {
      boletimSanitario: {
        mercadosDestino: {required}
      }
    }
  },
  data: () => ({
    listaMercadoDestino: [],
    loading: false,
    menu: false,
  }),
  computed: {
    listaMensagensSelecionadas() {
      if (!this.boletimSanitario.mercadosDestino) return []

      const msgs = this.boletimSanitario.mercadosDestino.map(md => md.dsMensagemBoletim)
      return _.uniq(msgs)
    }
  },
  props: {
    btnContinuar: Boolean,
    step: Number,
    boletimSanitario: {
      type: Object,
      required: true
    },
  },
  methods: {
    selecionarMercadoDestino(mercado) {
      if (!mercado) return
      const idx = this.boletimSanitario.mercadosDestino.findIndex(md => md.cdMercadoDestino === mercado.idMercadoDestino)
      if (idx > -1) {
        this.boletimSanitario.mercadosDestino = this.boletimSanitario.mercadosDestino.filter(md =>
            md.cdMercadoDestino !== mercado.idMercadoDestino
        )
      }
      else if (mercado.mensagensBoletimSanitario.length > 0) {
        this.boletimSanitario.mercadosDestino.push(
            ...mercado.mensagensBoletimSanitario.map(mensagem =>
                new MODELS.MENSAGEM_BOLETIM_SANITARIO(
                    mensagem.idMensagemBoletimSanitario,
                    mercado.idMercadoDestino,
                    mensagem.dsMensagemBoletimSanitario
                )
            )
        )
      }
    },
    loadListaMercadoDestino() {
      this.$axios.get(`mercado-destino/`)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) {
              this.listaMercadoDestino = []
              return
            }

            this.listaMercadoDestino = res.data[0].data.map((mercado, idx) => _.extend(mercado, {id: idx}))
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => this.loading = false)
    }
  },
  watch: {
    '$v.$invalid'(value) {
      this.$emit('update:btnContinuar', !value)
    },
  },
  mounted() {
    this.loadListaMercadoDestino()
  }
}
</script>

<style scoped lang="scss">
.route-view-card {
  background-color: #F2F5F3;
}

.titulo {
  font-family: Roboto;
  font-size: 32px;
  color: #35565B;
  opacity: 0.8;
}

.subtitulo {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7B9596;
}

.titulo--mensagens {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;

  color: #35565B;
}

.exibicao--mensagens {
  min-height: 212px;
  width: 100%;
  background: #F2F5F3;
  padding: inherit;
}

.card--mensagens--relacionadas {
  border-radius: 4px;
  background: white;
}

.placeholder--mensagens {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #BCCCCA;
}

.mensagem-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #35565B;
  white-space: pre-wrap;
  border: 1px solid #0090E9;
  background: #F2F5F3;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px;
}

</style>